'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { RiRocketLine } from 'react-icons/ri';
import OptimizeMenuContainer from '@/components/AppBar/OptimizeMenu/OptimizeMenuContainer';
import { sidebarRowStyles } from './sidebarItemStyles';
import { Tooltip } from '../ui/tooltip';
type OptimizeSidebarItemProps = {
  collapsed: boolean;
  networkId: string;
};
const OptimizeSidebarItem = t0 => {
  const $ = _c(18);
  const {
    collapsed,
    networkId
  } = t0;
  const t1 = !collapsed;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      placement: "right"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== collapsed) {
    t3 = sidebarRowStyles(collapsed, true);
    $[1] = collapsed;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = collapsed ? "center" : "flex-start";
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <RiRocketLine size={18} />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== collapsed) {
    t6 = !collapsed && <Text fontSize="sm" whiteSpace="nowrap">Optimize</Text>;
    $[4] = collapsed;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = <Flex alignItems="center" gap={3} justifyContent={t4} w="100%">{t5}{t6}</Flex>;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t3 || $[10] !== t7) {
    t8 = <Button aria-label="optimize-button" data-testid="sidebar-nav-optimize" {...t3}>{t7}</Button>;
    $[9] = t3;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== networkId || $[13] !== t8) {
    t9 = <Box w="100%"><OptimizeMenuContainer networkId={networkId} trigger={t8} /></Box>;
    $[12] = networkId;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t1 || $[16] !== t9) {
    t10 = <Tooltip content="Optimize" disabled={t1} openDelay={200} positioning={t2}>{t9}</Tooltip>;
    $[15] = t1;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default OptimizeSidebarItem;